import elem, {Message} from "element-ui";

/**
 * @description 获取页面的分页相关信息
 * @param headers 从请求中获取到的headers
 * @return {object} page : 当前页码 , pageCount: 总页数 , pageSize: 每页数据量 , total 总数据量
 *
 */
function getPaginationInfo(headers = error()) {
  let [page, pageCount, pageSize, total] = [headers["x-pagination-current-page"], headers["x-pagination-page-count"], headers["x-pagination-per-page"], headers["x-pagination-total-count"]];
  return {
    page: parseInt(page),
    pageCount: parseInt(pageCount),
    pageSize: parseInt(pageSize),
    total: parseInt(total),
  }
}

/**
 * @desc 格式化时间
 * @Author Training
 * @param {string} fmt
 * @return {string}
 */
Date.prototype.Format = function (fmt = "yyyy-MM-dd hh:mm:ss") { // author: meizz
  let o = {
    "M+": this.getMonth() + 1, // 月份
    "d+": this.getDate(), // 日
    "h+": this.getHours(), // 小时
    "m+": this.getMinutes(), // 分
    "s+": this.getSeconds(), // 秒
    "q+": Math.floor((this.getMonth() + 3) / 3), // 季度
    "S": this.getMilliseconds() // 毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (let k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : ((
        "00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}
String.prototype.toNumber = function () {
  return Number(this);
}
function arrItemToString(arr) {
  return arr.map(item => item + "");
}

/**
 * 参数为空错误警告
 * @param {string} paramName 参数名
 */
function error(paramName) {
  throw new Error("参数" + paramName + "不允许为空");
}

/**
 * @description 防抖函数
 * @param {function} fn 执行函数
 * @param {boolean} after 是否后执行(若用户多次点击 在多次点击后才执行fn, 如果为false则在用户点击时即开始执行fn, 后续点击不做操作);
 * @param {number} delay 延迟时间
 * */
export function debounce(fn, after, delay) {
  after = !!after;
  delay = delay || 500;
  let timer = null;
  let flag = false; // 是否已经执行函数;
  return function () {
    if (!after)
      if (flag) clearInterval(timer);
      else {
        fn.apply(this, arguments);
        flag = true;
      }
    else if (after && timer) clearInterval(timer);
    timer = setTimeout(() => {
      if (after) fn.apply(this, arguments);
      else flag = false;
    }, delay)
  }
}

/**
 * @description 节流
 * @param {function} fn 执行函数
 * @param {boolean} after 是否后执行
 * @param {number} delay 延时事件
 * @returns {(function(): void)|*}
 */
function throttle(fn, after, delay) {
  after = !!after;
  delay = delay || 500;
  let flag = false;
  let timer = null;
  return function () {
    if (flag === false) {
      if (!after) fn();
      flag = true;
    }
    if (!timer) {
      timer = setTimeout(function () {
        if (after) fn();
        flag = false;
        clearInterval(timer);
        timer = null;
      }, delay);
    }

  }
}

/** 格式化钱 */
function formatMoney(num) {
  let ts = num.toString(); // num to string -> ts
  let ta = (ts.indexOf(".") !== -1) ? ts.split('.') : [ts]; // num to array -> ta
  if (ta.length > 2) {
    return new Error("您输入的数据错误")
  } else {
    if (ta.length === 1) {
      return ta[0] + ".00"
    } else {
      if (ta[1].length === 1) {
        return ta[0] + "." + ta[1] + "0";
      } else {
        return num;
      }
    }
  }
}

function formatNumber(num) {
  let ts = num.toString(); // num to string -> ts
  let ta = (ts.indexOf(".") !== -1) ? ts.split('.') : [ts]; // num to array -> ta
  if (ta.length > 2) {
    return new Error("您输入的数据错误")
  } else {
    if (ta.length === 1) {
      return ta[0] + ".0"
    } else {
      return num;
    }
  }
}

/**
 * @desc 检查版本更新
 */
function checkVersionUpdate(currentVersion, serverVersion) {
  if (!serverVersion) return;
  // 判断是否有更新版本
  let current = currentVersion.split('.');
  let server = serverVersion.split('.');
  let have_new = false;
  for (let i = 0; i < 3; i++) {
    if (parseInt(current[i]) < parseInt(server[i])) {
      have_new = true;
      break;
    } else if (parseInt(current[i]) > parseInt(server[i])) {
      have_new = false;
      break;
    }
  }
  return have_new;
}

/**
 * @param {data:String(身份证号码),type:Number(加密类型: 0 身份证, 1 名字)}
 * @description 加密名字和身份证号码
 * @return {String}
 */
function secretId(data, type = 0) {
  let id = data + "";
  let format = "";
  for (let i = 0, len = id.length; i < len; i++) {
    if (type === 0) {
      if (i > 4 && i < len - 4) {
        format += "*"
      } else {
        format += id[i];
      }
    } else {
      if (i < len - 1) format += "*";
      else format += id[i];
    }
  }
  return format;
}

/**
 * @description 检测输入框内容正确与否
 * @param {string} type
 * @param {string|number} data
 *        type:
 *            empty: 输入的内容是否为空
 *            number: 输入数据是否为数字(或者小数)
 *            phone : 输入数据与电话号码匹配
 *            email : 输入数据是否为邮箱
 *            id      : 输入数据  身份证
 *            bank  : 输入数据是否为银行卡号
 *        data: 数据
 * */
function checkInput(type, data) {
  let reg = false;
  switch (type) {
    case "number":
      reg = /^[0-9\.\-]+$/
      break;
    case "phone":
      reg = /^1[1,3,5,6,7,8,9][0-9]{9}$/
      break;
    case "email":
      reg = /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/
      break;
    case "id":
      reg = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|[X,x]){1}$/
      break;
    case "bank":
      reg = /^([1-9]{1})(\d{16}|\d{15}|\d{18})$/
      break;
    case "qq":
      reg = /^[1-9][0-9]{4,9}$/
      break;
    case "empty":
      if (data == null) return true;
      reg = /^\s*$/
      break;
  }

  return reg && reg.test(data);
}

/**
 *
 * @param {Array |string} val 验证的值
 * @param {"&&" | "||"} reg 验证方式
 *        &&  验证数组val中的值是否全为空数据
 *        ||  验证数组val中的值是否有空数据
 * @return {boolean}
 */
const isEmpty = (val, reg = "&&") => {
  if (Array.isArray(val)) {
    let flag = false;
    for (let item of val) {
      if (reg === "&&" && item != null && item !== "") return false;
      else if (reg === "||" && (item == null || item === "")) return true;
    }
    return reg === "&&";
  } else return val == null || val === "";
};

/**
 * @description 批量验证表单数据
 * @param {array} options
 *    [{
 *        type:"", // 类型
 *        data:"" // 数据
 *    }]
 * @param {function} callback
 */
function checkInputs(options, callback) {
  try {
    options.forEach(item => {
      callback(item, checkInput(item.type, item.data))
    })
  } catch (e) {

  }
}

/**
 * @param {number} nums: 毫秒数
 * @param {function} callback: 回调
 * 倒计时
 * */

function count_down(nums, callback) {
  if (!callback) callback = function () {
  };
  let hours = Math.floor(nums / (3600000)); // 时
  let min = Math.floor((nums - hours * 3600000) / 60000) // 分
  let sec = Math.floor((nums - hours * 3600000 - min * 60000) / 1000) // 秒
  let timer = setInterval(function () {
    sec--;
    if (sec < 0) {
      min--;
      if (min < 0) {
        hours--;
        if (hours < 0) {
          clearInterval(timer);
          hours = 0;
          min = 0;
          sec = 0;
          callback(timer, [hours, min, sec])
          return
        }
        min = 59;
      }
      sec = 59;
    }
    callback(timer, [hours, min, sec])
  }, 1000)

}

//判断图片是否存在
function CheckImgExists(imgurl, callback) {
  let ImgObj = new Image(); //判断图片是否存在
  ImgObj.src = imgurl;
  ImgObj.onload = function (e) {
    //存在图片
    if (ImgObj.width > 0 && ImgObj.height > 0) {
      callback(true);
    } else {
      callback(false);
    }
  }
  ImgObj.onerror = function (e) {
    callback(false);
  }
}

/**
 * @desc 设置storage
 * @param {string} key
 * @param {any} value
 */
function setStorage(key, value) {
  if (!value) value = "";
  else if (typeof value === 'object') value = JSON.stringify(value);
  localStorage.setItem(key, value);
}

/**
 * @desc 获取storage的内容
 * @param {string} key
 */
function getStorage(key) {
  let value = localStorage.getItem(key);
  try {
    return JSON.parse(value);
  } catch (e) {
    return value;
  }
}

function GUID(format = "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx") {
  let char = ['A', 'B', 'C', 'D', 'E', 'F', 1, 2, 3, 4, 5, 6, 7, 8, 9, 0];
  let len = 0;
  for (let i in format)
    if (format[i] === 'x') len += 1;
  let random = () => {
    let i = parseInt(Math.random() * 15);
    return char[i];
  };
  return format.replace(/x/g, res => random())
}

/**
 * 判断时间是否在区间内
 * beginTime: 开始时间
 * endTime：结束时间
 * nowTime：现在的时间
 */
function contrastTime(beginTime, endTime, nowTime) {
  let strb = beginTime.split(":");

  let stre = endTime.split(":");

  let strn = nowTime.split(":");
  if (strn[0] >= strb[0] && strn[0] < stre[0]) {
    return true
  } else {
    return false
  }
}

/**
 * @desc 设置SessionStorage
 * @param {string} key
 * @param {any} value
 */
function setSession(key, value) {
  if (value == null) value = "";
  else if (typeof value === 'object') value = JSON.stringify(value);
  sessionStorage.setItem(key, value);
}

/**
 * @desc 获取SessionStorage的内容
 * @param {string} key
 */
function getSession(key) {
  let value = sessionStorage.getItem(key);
  try {
    return JSON.parse(value);
  } catch (e) {
    return value;
  }
}

/**
 * @description 获取json数据的最底层对象
 * @param obj
 * @param childName
 */
function getObjectLowerList(obj = error("object"), childName = "child") {
  let temp = [];
  let getList = (obj) => {
    if (Array.isArray(obj)) {
      if (obj.length === 0) return;
      for (let i = 0; i < obj.length; i++) {
        let item = obj[i];
        getList(item);
      }
    } else if (typeof obj === "object") {
      if (obj[childName] == null) {
        temp.push(obj);
      } else {
        getList(obj[childName]);
      }
    }
  }
  getList(obj, childName)
  return temp;
}

/**
 * @description 获取浏览器内核
 * @return {{name:string, version: string}}
 * @constructor
 */
function GetBrowser() {
  let Sys = {},
      ua = navigator.userAgent.toLowerCase(),
      s;
  (s = ua.match(/msie ([\d.]+)/)) ? Sys.ie = s[1] :

      (s = ua.match(/(trident)\/([\d.]+)/)) ? Sys.ie = s[2] :

          (s = ua.match(/firefox\/([\d.]+)/)) ? Sys.firefox = s[1] :

              (s = ua.match(/chrome\/([\d.]+)/)) ? Sys.chrome = s[1] :

                  (s = ua.match(/opera.([\d.]+)/)) ? Sys.opera = s[1] :

                      (s = ua.match(/version\/([\d.]+).*safari/)) ? Sys.safari = s[1] : 0;

  //以下进行测试
  let appName, appVersion;

  if (Sys.ie) {
    appName = "IE";
    appVersion = Sys.ie;
  }

  if (Sys.firefox) {
    appName = "Firefox";
    appVersion = Sys.firefox;
  }

  if (Sys.chrome) {
    appName = "Chrome";
    appVersion = Sys.chrome;
  }

  if (Sys.opera) {
    appName = "Opera";
    appVersion = Sys.opera;
  }

  if (Sys.safari) {
    appName = "Safari";
    appVersion = Sys.safari;
  }
  return {
    "name": appName,
    "version": appVersion
  };
}

/**
 * @description 深度优先遍历选择框组树
 * @param {JSON|Array}node  数据节点
 * @param {Object}options {
 *     child  子节点名 , 默认data
 *     selected 是否选中
 *     isFirst 第一次遍历
 * }
 * @param callback
 * @return {*}
 */
function eachCheckboxTree(node, options = {},callback = ()=>{}) {
  let _options = Object.assign({}, {
    child: "data",
    selected: null,
    isFirst: false,
    parent:true
  }, options);
  let {
    child,
    selected,
    isFirst,
    parent
  } = _options;
  let nodes = [];
  if (!!node) {
    let stack = [];
    if (Array.isArray(node)) {
      for (let i = node.length - 1; i >= 0; i--) {
        let item = node[i];
        if (isFirst) {
          let children = item[child] || [];
          item.tier = 0;
          // item.index = i;
          item.ground = children.length === 0;
        }
        stack.push(item);
      }
    } else if (typeof node === "object") {
      if (isFirst) {
        node.tier = 0;
        let children = node[child] || [];
        node.ground = children.length === 0;
      }
      stack.push(node);
    }
    while (stack.length > 0) {
      let item = stack.pop();
      nodes.push(item);
      let children = item[child] || [];
      let ground = false;
      let tier = item.tier;
      if (selected != null)
        item.selected = selected;
      if (isFirst) {
        tier++;
        ground = children.length === 0;
      }
      for (let i = children.length - 1; i >= 0; i--) {
        let c = children[i];
        if (isFirst) {
          c.ground = ground;
          if(parent)
            c.parent = item;
          c.tier = tier;
          // c.index = i;
        }
        stack.push(c);
      }
      callback(item)
    }
  }
  return node;
}

/**
 * @description  操作多选框组
 * @param item 当前操作的数据
 * @param indexes 下标组 以逗号隔开
 */
function handleCheckedGroup(item, childName, indexes) {
  let checked = item.selected;
  item = eachCheckboxTree(item, {
    selected: checked,
    child: childName
  });
  let eachParent = (node) => {
    if (node == null) return;
    let data = node[childName];
    let flag = true;
    for (let k in data) {
      let item = data[k];
      if (!item.selected) {
        flag = false;
        break;
      }
    }
    node.selected = flag;
    eachParent(node.parent);
  }
  eachParent(item.parent);
}


/**
 * @description 深度优先遍历
 * @param {Array,JSON} data 数据
 * @param {function} callback 回调
 * @param {{child?:string,tier?:boolean}} options 配置选项
 * @constructor
 */
function DFS(data, callback = error('callback'), options = {}) {
  let _options = Object.assign({}, {
    child: "data",
    tier:true
  }, options);
  let {
    child
  } = _options;

  const setTier = (item,value)=>{
    if (_options.tier)item._tier = value;
  }
  if (!!data) {
    let stack = [];
    if (Array.isArray(data))
      for (let i = data.length - 1; i >= 0; i--) {
        let item = data[i];
        setTier(item,0);
        stack.push(item);
      }
    else if (typeof data === "object") {
      setTier(data,0);
      stack.push(data);

    }
    while (stack.length > 0) {
      let item = stack.pop();
      let tier = item._tier;
      tier++;
      callback(item);
      let children = item[child] || [];
      for (let i = children.length - 1; i >= 0; i--) {
        setTier(children[i],tier);
        stack.push(children[i]);
      }
    }
  }
}

/**
 * 广度优先遍历
 * @param data
 * @param callback
 * @param options
 * @constructor
 */
function BFS(data,callback=error('callback'),options={}){
  let _options = Object.assign({
    child:'data',
    tier:true
  },options)
  let child = _options.child;
  const setTier = (item,value)=>{
    if (_options.tier)item._tier = value;
  }
  if(!!data){
    let queue = [];
    if (Array.isArray(data))
      for (let i = 0; i < data.length; i++) {
        let item = data[i];
        setTier(item,0);
        queue.push(item);
      }
    else if (typeof data === "object") {
      setTier(data,0);
      queue.push(data);
    }
    while (queue.length > 0) {
      let item = queue.shift();
      let tier = item._tier;
      tier++;
      callback(item);
      let children = item[child] || [];
      for (let i = 0; i < children.length; i++) {
        setTier(children[i],tier);
        queue.push(children[i]);
      }
    }
}
}
/**
 * @description 获取对象的数量
 * @param obj
 * @return {number}
 */
function length(obj) {
  if (Array.isArray(obj) || typeof obj === "string") return obj.length;
  else if (typeof obj === "object") {
    return Object.keys(obj).length;
  } else {
    throw new Error("[Type Error] length 方法的参数应该为 Object , 不应为:" + typeof obj);
  }
}

/**
 * @description 将json对象转换为map对象
 * @param obj
 * @return {Map<any, any>}
 * @constructor
 */
function jsonToMap(obj) {
  let m = new Map();
  for (let i in obj) m.set(i, obj[i]);
  return m;
}

/**
 * @description 将简单的JSON对象转换为Array
 * @param obj
 * @param {{key:String,val:String}} config 配置
 * @constructor
 */
function jsonToArray(obj,config={key:"key",val:"val"}) {
  if (Array.isArray(obj))return [];
  let temp = []
  let {key,val} = config;
  for (let k in obj) {
    temp.push({
      [key]: k,
      [val]: obj[k]
    })
  }
  return temp;
}

/**
 * @description 将对象中的数字,或字符串互相转换
 * @param obj 对象,数组
 * @param type 转换类型 0 ,转数字 , 1 转字符串
 * @return {Object}
 */
function objectNumberToggle(obj, type) {
  for (let k in obj) {
    let item = obj[k];
    if (!type && typeof item !== "number") {
      obj[k] = parseInt(item);
    } else if (type && typeof item !== "string")
      obj[k] += "";
  }
  return obj;
}

/**
 * @desc 十六进制颜色转十进制 rgba()
 * @param {string} color
 * @param {number} opacity
 */
function colorHEXToDEC(color, opacity = 1) {
  const _cont = color.split("#")[1];
  let rgba = [];
  for (let i = 0; i < _cont.length; i += 2) {
    let str = _cont.slice(i, 2 + i);
    rgba.push(parseInt(str, 16))
  }
  rgba.push(opacity);
  return `rgba(${rgba.join(",")})`;
}

/**
 * @description 网络错误处理函数
 * @param err Error对象
 */
function networkHandle(err, showMsg = true) {
  const msg = err.message.toLowerCase();
  let text = "";
  if (msg.indexOf("timeout") > -1) {
    text = "请求超时";
  } else if (msg.indexOf("network") > -1) {
    text = "网络连接错误";
  } else text = err.message;
  if (showMsg)
    elem.Message.error({
      message: text,
      showClose: true,
      duration: 3000
    })
}

/**
 * @desc 全局监听promise catch的错误请求 , 并不在控制台打印
 * @param {function} callback 回调函数
 */
function listenPromiseCatch(callback = (e) => {
}) {
  window.onunhandledrejection = function (event) {
    event && event.preventDefault();
    callback(event.reason);
  }
}

/**
 * @desc 禁用鼠标滚轮缩放页面
 */
function disableMousewheel() {
  document.addEventListener('keydown', function (event) {
    if ((event.ctrlKey === true || event.metaKey === true)
        && (event.which === 61 || event.which === 107
            || event.which === 173 || event.which === 109
            || event.which === 187 || event.which === 189)) {
      event.preventDefault();
    }
  }, false);
// Chrome IE 360
  window.addEventListener('mousewheel', function (event) {
    if (event.ctrlKey === true || event.metaKey) {
      event.preventDefault();
    }
  }, {passive: false});

//firefox
  window.addEventListener('DOMMouseScroll', function (event) {
    if (event.ctrlKey === true || event.metaKey) {
      event.preventDefault();
    }
  }, {passive: false});
}

/**
 * 根据屏幕宽度计算rem值
 * @param width 参考设计图(标准)宽度
 * @param minWidth 最小屏幕宽度
 * @param setHtml 是否设置html标签的font-size(因为在一些情况下 , 只需要计算比例 , 不需设置rem基数)
 * @return {number} 屏幕宽度和设计标准宽度的比率
 */
function calcRem (width=1920,minWidth=1440,setHtml=true){
  let ww = document.documentElement.clientWidth;
  ww = ww <1440?1440:ww;
  let rate = ww / width;
  if (setHtml)
    document.querySelector("html").style.fontSize = (rate) + "px"
  return rate;
}
const constants = {
  // 用户的账号和密码信息
  loginInfo: "LOGIN_INFO",
  // 用户的token信息
  token: "TOKEN",
  // 第三方登录的类型
  loginType: "LOGIN_TYPE",
  // 用户信息
  userInfo: "USER_INFO",
  // 用户权限菜单配置
  menuConfig: "MENU_CONFIG",
  // 用户当前角色的校区列表
  schoolList: "SCHOOL_LIST",
  // 用户当前页面按钮权限
  buttonPermissions: "BUTTON_PERMISSIONS"
}

/**
 * @description 文件下载
 * @name 下载文件标题
 * @format 下载文件格式: 默认为CSV格式可不传
 * @data 下载文件数据
 */
function download(name, data, format = 'csv') {
  const filename = name + '.' + format;
  const blob = new Blob([data]);
  let downloadElement = document.createElement('a');
  let href = window.URL.createObjectURL(blob);
  downloadElement.href = href;
  downloadElement.download = decodeURIComponent(filename);
  document.body.appendChild(downloadElement);
  downloadElement.click();
  document.body.removeChild(downloadElement);
  window.URL.revokeObjectURL(href);
}

function numberToChinese(number) {
  const chineseNumber = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  const chineseUnit = ['', '十', '百', '千', '万', '亿']

  let result = ''
  let numStr = String(number)

  for (let i = 0; i < numStr.length; i++) {
    let digit = Number(numStr[i])
    let unit = numStr.length - i - 1

    if (digit === 0) {
      if (unit === 4 || unit === 8) {
        result += chineseUnit[unit]
      } else if (result[result.length - 1] !== chineseNumber[0]) {
        result += chineseNumber[digit]
      }
    } else {
      result += chineseNumber[digit] + chineseUnit[unit]
    }
  }

  return result
}

/**
 * @description 复制文本到剪贴板
 * @param value 要复制的文本
 */

function copyToClipboard(value) {
  let tempInput = document.createElement('textarea');
  tempInput.value = value;
  document.body.appendChild(tempInput);
  tempInput.select();
  document.execCommand('copy');
  document.body.removeChild(tempInput);
}

/**
 * 选择文件
 * @param options
 * @param {Function} callback 回调
 */
export function chooseFile(options = {},callback = error("callback")){
  // quality图片压缩比
  let {accept,multiple,quality} = Object.assign({accept:"image/png,image:/jpg",multiple:false,quality:0.6},options);
  let ipt = document.createElement('input');
  ipt.type = 'file';
  ipt.accept = accept;
  ipt.multiple = multiple;
  ipt.click();
  ipt.addEventListener('change',async(e)=>{
    let res = [];
    let files = e.target.files;
    if (accept.includes('image') && quality !== 1){
      for (let i = 0;i < files.length;i ++){
        await compressImage(files[i],quality).then(r=>{
          res[i] = r;
        });
      }
    }else res = files;
    callback(res,e);
  })
}

/**
 * 图片压缩
 * @param file
 * @param quality 压缩比 0-1
 * @return {Promise<File>}
 */
function compressImage(file,quality){
  let format = file.type;
  let img = new Image();
  let winURL = window.URL||window.webkitURL;
  img.src = winURL.createObjectURL(file);
  return new Promise((resolve,reject)=>{
    img.onload = function () {
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext('2d');
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img,0,0,img.width,img.height);
      let newData = canvas.toDataURL("image/jpeg",quality);
      let bstr = window.atob(newData.split(',')[1]);
      let n = bstr.length;
      if (n > file.size)return resolve(file);
      let u8 = new Uint8Array(n);
      while(n--){
        u8[n] = bstr.charCodeAt(n);
      }
      resolve(new File([u8],file.name,{type:format}));
    }
    img.onerror=reject;
  })
  // img.src = file.src;

}

function newFilesName(fileUrl, newName = '') {
  fetch(fileUrl).then(response => {
    if (!response.ok) Message.error('网络响应失败')
    return response.blob();
  }).then(blob => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = newName;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }).catch(() => Message.error('下载失败'));
}

const echartsColor = ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc', '#42D45D', '#D4AB64', '#16D4BE', '#D11A11', '#968FD1', '#90D187', '#B1D12F', '#C936A4', '#B7C99C', '#C9C20D', '#C9098F', '#8760C9', '#14C9C6', '#9EC994', '#C9B428']

const tools = {
  constants,
  error,
  getPaginationInfo,
  contrastTime,
  GUID,
  getStorage,
  setStorage,
  setSession,
  getSession,
  CheckImgExists,
  count_down,
  checkInput,
  checkInputs,
  secretId,
  checkVersionUpdate,
  formatMoney,
  throttle,
  debounce,
  getObjectLowerList,
  GetBrowser,
  eachCheckboxTree,
  handleCheckedGroup,
  arrItemToString,
  DFS,
  BFS,
  length,
  jsonToMap,
  formatNumber,
  jsonToArray,
  objectNumberToggle,
  networkHandle,
  colorHEXToDEC,
  isEmpty,
  disableMousewheel,
  listenPromiseCatch,
  download,
  echartsColor,
  numberToChinese,
  calcRem,
  copyToClipboard,
  chooseFile,
  compressImage,
  newFilesName
}
export default tools;
